import { useQuery } from '@apollo/client'
import {
  AppBar,
  Button,
  Container,
  Stack,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material'
import { Query, RetailerAccount } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import { useHistory } from 'react-router-dom'

import organicCampaignPaths from '@src/components/content/organicCampaignPaths'
import HelpDropdown from '@src/components/shared/TopNav/HelpDropDown'
import useCurrentAuth from '@src/lib/useCurrentAuth'

import publicCampaignPaths from './publicCampaignPaths'
import PublicCampaignViewLayout from './PublicCampaignViewLayout'
import { GET_PUBLIC_CAMPAIGN_SHARES_QUERY } from './queries'
const PublicCampaign: React.FC = () => {
  const history = useHistory()
  const { currentUser, retailerAccounts } = useCurrentAuth()

  const params = publicCampaignPaths.publicDetails.useParams()
  const { data, loading } = useQuery<Query>(GET_PUBLIC_CAMPAIGN_SHARES_QUERY, {
    variables: {
      campaignId: params.campaignId,
    },
  })

  // Redirect to the correct retailer account if the user is logged in, based on original R1 behavior
  if (currentUser && data && !loading && retailerAccounts.length) {
    const currentRetailerAccount = retailerAccounts.find(
      (retailerAccount: RetailerAccount) =>
        retailerAccount?.retailers?.find(
          (y) => y.brand_id === data?.getCampaign?.brand?.id,
        ),
    )
    if (currentRetailerAccount && currentRetailerAccount.slug) {
      history.push(
        organicCampaignPaths.details.build({
          campaignId: params.campaignId,
          retailerAccountSlug: currentRetailerAccount.slug,
          channel: 'facebook',
        }),
      )
    }
  }

  if (loading) return null

  return (
    <>
      <AppBar
        position="fixed"
        sx={(theme: Theme) => ({
          backgroundColor: theme.palette.pbxxCyan.main,
          color: theme.palette.pbxxCyan.contrastText,
        })}
      >
        <Toolbar>
          <div style={{ flexGrow: 1 }} />
          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Typography>{I18n.t('auth.existingUserQuestionMark')}</Typography>
            <Button
              color="primary"
              variant="contained"
              size="large"
              href={`/login?redirect_url=${encodeURIComponent(
                window.location.href,
              )}`}
            >
              {I18n.t('auth.login')}
            </Button>
          </Stack>
          <HelpDropdown />
        </Toolbar>
      </AppBar>
      {/* Extra toolbar used as easy spacer */}
      <Toolbar />
      <Container sx={{ marginTop: 5 }}>
        <PublicCampaignViewLayout campaign={data?.getCampaign} />
      </Container>
    </>
  )
}

export default PublicCampaign
